import type React from 'react';
import { useLocation } from 'react-router-dom';
import { useTenderDetails } from '../../contexts/TenderDetailsContext';
import ReviewSectionsStep from './ReviewSectionsStep';
import { getLoadingKey } from './utils';
import WorkflowStep from './WorkflowStep';

const ReviewAndEditStep: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const actionSectionId = searchParams.get('actionSectionId');

  const {
    canManageTender,
    isPartnerView,
    openStep,
    setOpenStep,
    reviewStepComplete,
    sectionsCount,
    validTenderId,
    tender,
    handleQuickReview,
    loadingStates,
    setReviewStepComplete,
  } = useTenderDetails();

  if (isPartnerView) {
    return null;
  }

  return (
    <WorkflowStep
      stepNumber={canManageTender ? 9 : 3}
      expanded={openStep === 9}
      onChange={(_, isExpanded) => setOpenStep(isExpanded ? 9 : null)}
      title="Review & Edit Proposal"
      description="Review generated sections, edit content, and compile the final draft."
      isComplete={reviewStepComplete}
      isInProgress={sectionsCount > 0 && !reviewStepComplete}
    >
      <ReviewSectionsStep
        tenderId={validTenderId}
        tender={tender}
        onQuickReview={handleQuickReview}
        isQuickReviewing={
          (!!tender.reviewResponse?.status &&
            tender.reviewResponse.lastType === 'quick' &&
            !tender.reviewResponse.status.toLowerCase().includes('complete') &&
            !tender.reviewResponse.status.toLowerCase().includes('error') &&
            !tender.reviewResponse.status.toLowerCase().includes('failed')) ||
          loadingStates[getLoadingKey(validTenderId, 'regenerate', 'quick_review')] ||
          false
        }
        isCompiling={tender.compileStatus?.status === 'processing'}
        onCompletionChange={setReviewStepComplete}
        actionSectionId={actionSectionId}
      />
    </WorkflowStep>
  );
};

export default ReviewAndEditStep;
